import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, Container } from 'react-bootstrap';
import SearchBar from '../components/SearchBar.tsx';
import PostIdSearch from '../components/PostIdSearch.tsx'; 
import CommunitySearch from '../components/CommunitySearch.tsx';
import MemberSearch from '../components/MemberSearch.tsx';
import ProposalSearch from '../components/ProposalSearch.tsx';
import ReviewSearch from '../components/ReviewSearch.tsx';
import ParameterGroups from '../components/ParameterGroups.tsx';
import ConsensusBounties from '../components/ConsensusBounties.tsx';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SearchResults() {
  const query = useQuery();
  const navigate = useNavigate();

  const searchType = query.get('type') || "Community"; // Default to "Post"
  const searchValue = query.get('value') || "";

  const handleSearch = (type: string, value: string) => {
    // Ensure that the query parameters get updated correctly
    navigate(`/search-results?type=${encodeURIComponent(type)}&value=${encodeURIComponent(value)}`);
  };

  useEffect(() => {

  }, [searchType, searchValue]);

  const renderSearchComponent = () => {
    switch (searchType) {
      case 'Post':
        return <PostIdSearch value={searchValue} />;
      case 'Community':
        return <CommunitySearch value={searchValue} />;
      case 'Member':
        return <MemberSearch value={searchValue} />;
      case 'Review':
        return <ReviewSearch value={searchValue} />;
      case 'Proposal':
        return <ProposalSearch value={searchValue} />;
      case 'Bounties':
        return <ConsensusBounties value={searchValue} />;
      case 'ParameterGroups':
        return <ParameterGroups value={searchValue} />;
      default:
        return <div>No valid search type selected</div>;
    }
  };

  return (
    <Container className="mt-5">
      <SearchBar 
        initialSearchType={searchType}
        initialSearchValue={searchValue}
        onSearch={handleSearch}
      />
      <Card style={{marginBottom:"20px"}}>
        <Card.Body>
          {renderSearchComponent()}
        </Card.Body>
      </Card>
    </Container>
  );
}

export default SearchResults;
